import { Button, HStack, Select } from '@montel/montelpro-shared-components-v2';
import { SUBSCRIPTIONS_ASSIGN_SEAT } from 'apiRoutes';
import { RequestLoader } from 'components/common/Loader';
import { StandardModal } from 'components/common/Modal/StandardModal';
import { MontelAccount } from 'domain/account/interfaces';
import useSubmit, { POST } from 'hooks/useSubmit';
import { useState } from 'react';
import { RequestStatus } from 'types/RequestStatus';

export const AssignSeatToExternalUserModal: React.FC<{
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	subscriptionId: number;
	onSeatAssigned: () => void;
	allUsers: MontelAccount[];
	allUsersStatus?: RequestStatus;
}> = ({
	setShowModal,
	showModal,
	subscriptionId,
	onSeatAssigned,
	allUsers,
	allUsersStatus = RequestStatus.UNLOADED,
}) => {
	const [selectedUserId, setSelectedUserId] = useState<string>();

	const [assignSeat, assignSeatStatus] = useSubmit(
		`${SUBSCRIPTIONS_ASSIGN_SEAT}`,
		POST,
		{
			messageOnError: 'An error occurred while assigning the user.',
			messageOnSuccess: 'User assigned successfully.',
			showApiError: true,
		},
	);

	const onAssignSeat = async () => {
		if (!selectedUserId) return;

		const result = await assignSeat({
			subscriptionId: subscriptionId,
			subscriberId: selectedUserId,
		});
		if (result.success) {
			onSeatAssigned();
			setShowModal(false);
		}
	};

	return (
		<StandardModal
			isOpen={showModal}
			onClose={() => setShowModal(false)}
			header={'Assign seat to external user'}
		>
			<RequestLoader status={allUsersStatus}>
				<HStack gap="md">
					<Select
						label=""
						placeholder="Select a user"
						options={allUsers?.map((user) => ({
							value: user.id,
							label: `${user.firstName} ${user.lastName} (${user.email.value})`,
						}))}
						onChange={(userOption) => {
							if (userOption) {
								setSelectedUserId(userOption.value);
							}
						}}
					/>
					<Button
						text="Assign Seat"
						size="sm"
						type="submit"
						isLoading={assignSeatStatus === RequestStatus.LOADING}
						loadingText="Assigning seat..."
						onClick={onAssignSeat}
						isDisabled={!selectedUserId}
					/>
					<Button
						text="Cancel"
						size="sm"
						variant="secondary"
						onClick={() => setShowModal(false)}
					/>
				</HStack>
			</RequestLoader>
		</StandardModal>
	);
};
